// eslint-disable-next-line import/prefer-default-export
export const convertM2ToAc = m2 => {
  const factorOfConversationToAc = 4046.864224;
  return parseFloat(m2) / factorOfConversationToAc;
};
